import { Component, uiElement } from "@kluntje/core";
import { addClass, onEvent } from "@kluntje/js-utils/lib/dom-helpers";
import { DebuggerService } from "@kluntje/services";
import { Pagination } from "Components/sde-m-pagination/sde-m-pagination";
import { PAGINATION_CHANGED } from "Constants/eventTypes";
import { renderTemplate } from "Helper/renderHelper/renderTemplate";
import LocalEventsService from "Services/LocalEventsService";

export class SDEEventsOverview extends Component {
  private _pagination?: Pagination;

  @uiElement(".sde-m-events-overview__events")
  private eventsBox: HTMLDivElement;

  private get pagination(): Pagination {
    if (this._pagination !== undefined) return this._pagination;

    const paginationElement = document.createElement("sde-m-pagination") as Pagination;
    addClass(paginationElement, "sde-m-pagination", "sde-m-events-overview__pagination");
    this._pagination = paginationElement;

    onEvent(paginationElement, PAGINATION_CHANGED, this.handlePaginationChange, this);

    this.appendChild(paginationElement);
    return paginationElement;
  }

  private get pageSize(): number {
    return 10;
  }

  private get currentPage(): number {
    return this.pagination.activeItem + 1;
  }

  protected afterComponentRender(): void {
    this.init();
  }

  private async init() {
    const apiResponse = await LocalEventsService.getEvents({
      pageSize: this.pageSize,
      page: 1,
      locations: ["Süderende"],
    });

    if (!apiResponse || apiResponse.resultCount === 0) {
      DebuggerService.warn("No events found");
      return;
    }

    const pageCount = Math.ceil(apiResponse.resultCount / this.pageSize);

    if (pageCount > 1) {
      this.pagination.setAttribute("page-count", pageCount.toString());
    }
    const { contentTemplate } = await import("./sde-m-events-overview.template");
    renderTemplate(contentTemplate({ events: apiResponse.events }), this.eventsBox, { clearSSRContent: true });
  }

  private async renderCurrentPage() {
    await this.renderPlaceholders();
    const apiResponse = await LocalEventsService.getEvents({
      pageSize: this.pageSize,
      page: this.currentPage,
      locations: ["Süderende"],
    });

    if (!apiResponse || apiResponse.resultCount === 0) {
      DebuggerService.warn("No events found");
      return;
    }

    const { contentTemplate } = await import("./sde-m-events-overview.template");
    renderTemplate(contentTemplate({ events: apiResponse.events }), this.eventsBox, { clearSSRContent: true });
  }

  private async renderPlaceholders() {
    const { placeholderTemplate } = await import("./sde-m-events-overview.template");
    renderTemplate(placeholderTemplate(this.pageSize), this.eventsBox, { clearSSRContent: true });
  }

  private handlePaginationChange() {
    this.renderCurrentPage();
  }
}

customElements.define("sde-m-events-overview", SDEEventsOverview);
